<div class="sgt-pedido-table-badges-container" *ngIf="pedido">
    <!-- Plataforma de Origem -->
    <sgt-plataforma-origem-badge
        [origem]="pedido.origemLancamento"
        [logoURLErp]="pedido.logoURLPlataformaIntegracaoErp"
        [nomeErp]="pedido.nomeIntegracaoErp"
        [logoURLEcommerce]="pedido.logoURLPlataformaIntegracaoEcommerce"
        [nomeEcommerce]="pedido.nomeIntegracaoEcommerce"
        logoURLWidth="20px"
        [isShowNome]="false">
    </sgt-plataforma-origem-badge>

    <!-- ERP v1 -->
    <span 
        *ngIf="config?.isOrigemERP && isIntegracaoErpV1"
        class="badge badge-secondary-light" 
        style="padding: 5px;"
        title="Pedido Lançado no ERP">
        ERP
    </span>

    <!-- Pedido Filho -->
    <span
        *ngIf="pedido.pedidoFilho" 
        class="badge badge-info-light" 
        style="padding: 5px;"
        title="Pedido Filho">
        P.F.
    </span>

    <!-- Canal de Venda -->
    <sgt-canal-venda-logo-badge
        *ngIf="!config?.isCanalVendaDireto"
        [logoMiniURL]="pedido.canalVenda.logoMiniURL"
        [nome]="pedido.canalVenda.nome"
        [useAsMini]="true"
        [isShowNome]="false"
        [styles]="{
            width: '18px'
        }">
    </sgt-canal-venda-logo-badge>

    <!-- Pedido Fracionado -->
    <sgt-pedido-fracionado-badge
        *ngIf="pedido.pedidoFracionado"
        [label]="null"
        [styles]="{
            fontSize: '10px',
            padding: '3px'
        }">
    </sgt-pedido-fracionado-badge>
</div>